import React, {Component} from 'react';
import {withAuth} from '@okta/okta-react';

// Basic component with logout button
export default class LogoutComponent extends Component {
    constructor(props) {
        super(props);
        this.props.auth.logout({postLogoutRedirectUri: 'https://www.mosis2.com/'});
    }


    render() {
        return (<a onClick='javascript:void(0)'>Logout</a>);
    }
}

// withAuth() makes Okta "Auth" object available as "this.props.auth"
LogoutComponent = withAuth(LogoutComponent);